import { EditorState, convertFromRaw, ContentState, convertToRaw } from 'draft-js';

const IsJsonString = value => {
  try {
    JSON.parse(value);
  } catch (e) {
    return false;
  }
  return true;
};

const isString = value => typeof value === 'string' && value !== null;

const isObject = value => {
  return typeof value === 'object' && value !== null;
};

const isEditorState = value => {
  try {
    value.getCurrentContent();
  } catch (e) {
    return false;
  }
  return true;
};

// create initial editor state from whatever is passed into the component
export const createRichTextEditorState = initialText => {
  // if value is already an existing valid editorState
  if (initialText && isEditorState(initialText)) {
    return initialText;
  }

  // if value is an object, we assume it's the raw draftJs content state
  if (initialText && isObject(initialText)) {
    return EditorState.createWithContent(convertFromRaw(initialText));
  }
  // if value is a  string and not a json encoded
  if (initialText && isString(initialText) && !IsJsonString(initialText)) {
    return EditorState.createWithContent(ContentState.createFromText(initialText));
  }
  // if value is a string that is json encoded
  if (initialText && isString(initialText) && IsJsonString(initialText)) {
    return EditorState.createWithContent(convertFromRaw(JSON.parse(initialText)));
  }
  // otherwise, initialize as empty EditorState
  return EditorState.createEmpty();
};

export const editorStateToJsonString = editorState => {
  // ensure editorState param is editorState object
  const convertedState = createRichTextEditorState(editorState);
  const contentState = convertedState.getCurrentContent();
  return JSON.stringify(convertToRaw(contentState));
};

export const isEmpty = initialText => {
  const editorState = createRichTextEditorState(initialText);
  const hasText = editorState.getCurrentContent().getPlainText().replace(/\s/g, '');
  const hasEntity = Object.keys(convertToRaw(editorState.getCurrentContent()).entityMap).length;
  return !hasText && !hasEntity;
};
